import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Map } from 'immutable';
import styles from './style.scss';

function FullAddress({ address = [], name }) {
  const safeAddress = typeof address === 'string' && address === '' ? [] : address;

  return (
    <div className={styles.fullAddress}>
      <div>{name}</div>
      {safeAddress.map((a) => (
        <div>{a}</div>
      ))}
    </div>
  );
}

FullAddress.propTypes = {
  address: PropTypes.object,
};

function Location({ settings, event, className = '', withIcon = false, style }) {
  if (event.get('online_event') || event.get('venue', Map()).isEmpty()) {
    return null;
  }
  // const latitude = event.getIn(['venue', 'address', 'latitude']);
  // const longitude = event.getIn(['venue', 'address', 'longitude']);
  const multi_line_address_display = event.getIn(['venue', 'multi_line_address_display']);

  const city = event.getIn(['venue', 'address', 'city']) || '';

  // Build location query from venue name and address (same as getLocationLink)
  const locationQuery = [event.get('venue_name'), multi_line_address_display].filter(Boolean).join(', ');

  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(locationQuery)}`;

  const fullArea =
    event.getIn(['venue', 'address', 'localized_multi_line_address_display']) ||
    (multi_line_address_display && multi_line_address_display.split(','));
  const name = event.getIn(['venue', 'name']);

  const showFullAddress = settings.get('showFullAddress');

  const nameWithCity = settings.get('showCity') ? `${name}, ${city}` : name;
  const address = showFullAddress ? <FullAddress name={name} address={fullArea} /> : nameWithCity;
  if (!address) return null;
  if (withIcon) {
    return (
      <a href={mapSrc} className={cn('location')} style={style} target="_blank" rel="noreferrer">
        {address}
      </a>
    );
  }
  return (
    <a href={mapSrc} className={cn('location', className, styles.location)} style={style} target="_blank" rel="noreferrer">
      {address}
    </a>
  );
}

export default Location;
